import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import {
  Integration,
  IntegrationEntity,
} from '@internal/backstage-plugin-catalog-devops-module-integrations-common';
import {
  DefaultApiClient,
  DefaultApiResponse,
} from '@internal/backstage-plugin-devops-react';
import { IntegrationsApi } from './IntegrationsApi';

export class IntegrationsApiClient
  extends DefaultApiClient
  implements IntegrationsApi
{
  public constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    super({
      backendName: 'catalog',
      ...options,
    });
  }

  async getIntegrations(): Promise<Integration[]> {
    const urlSegment = `v2/integration`;
    const response = await this.get(urlSegment);
    return response.body.items;
  }

  async getIntegration(integrationId: string): Promise<Integration> {
    const urlSegment = `v2/integration/${integrationId}`;
    const response = await this.get(urlSegment);
    return response.body.item;
  }

  async createIntegrationEntity(
    data: Integration,
  ): Promise<DefaultApiResponse> {
    const urlSegment = `v2/integration`;
    return await this.post<Integration>(urlSegment, data);
  }

  async editIntegrationEntity(
    id: string,
    data: Integration,
  ): Promise<DefaultApiResponse> {
    const urlSegment = `v2/integration/${id}`;
    return await this.put<Integration>(urlSegment, data);
  }

  async deleteIntegrationEntity(id: string): Promise<DefaultApiResponse> {
    const urlSegment = `v2/integration/${id}`;
    return await this.delete(urlSegment);
  }

  async triggerProvider(providerType: string): Promise<DefaultApiResponse> {
    const urlSegment = `v2/integration/provider/trigger?providerType=${encodeURIComponent(
      providerType,
    )}`;
    return await this.get(urlSegment);
  }

  async dryRun(data: IntegrationEntity): Promise<DefaultApiResponse> {
    const urlSegment = `v2/integration/dry-run`;
    return await this.post(urlSegment, data);
  }

  async run(data: IntegrationEntity): Promise<DefaultApiResponse> {
    const urlSegment = `v2/integration/run`;
    return await this.post(urlSegment, data);
  }
}
